export const MODULATORS_CONSUMPTIONS_CHART_CARD_FRENCH_LOCALE = {
  title: "Consommation",
};
